<h1 mat-dialog-title class="">
  <span class="w-100 h5 m-0">
    <span class="d-inline-block list-row-icon">
      <i class="rt-icon rt-certificate fs40 me-2"></i>
      {{ 'WEB-SIGN.SIGNTRUST-LIB.SIGNATURE-FLOW.CERTIFICATE-SELECTION' | translate }}
    </span>
  </span>
</h1>
<div mat-dialog-content class="w-100 bg-white">
  <div class="px-lg-2 certificates-list-header">
    <div class="certificates-list-search">
      <mat-form-field>
        <input matInput autocomplete="off" (keyup)="$event.stopPropagation(); $event.preventDefault(); applyFilter($event.target.value)" placeholder="Search" #searchInput/>
        <i matSuffix *ngIf="searchInput.value" (click)="$event.stopPropagation(); $event.preventDefault(); applyFilter(''); searchInput.value = ''" class="rt-icon rt-cerrar pointer fs18 me-2"></i>
      </mat-form-field>
    </div>
    <div class="certificates-list-description">
      <span> {{ 'WEB-SIGN.SIGNTRUST-LIB.CERTIFICATES-LIST.AVAILABLE-CERTIFICATES' | translate }} </span>
    </div>
  </div>
  <div class="certificates-list-content">
    <div class="certificates-list-content">
      <ng-container *ngIf="loadingInfo; then loadingPoints; else certificates"></ng-container>
      <ng-template #loadingPoints>
        <div class="certificates-list-loading">
          <span class="loader"></span>
        </div>
      </ng-template>
      <ng-template #certificates>
        <ng-container *ngIf="dataSource?.filteredData.length > 0">
          <div class="card-wrapper" *ngFor="let certificate of dataSource?.filteredData">
            <div class="card-content w-100" (click)="focusCertificate(certificate)">
              <div class="card-select-button">
                <mat-radio-button color="primary" [checked]="focusedCertificate?.certificateHandler === certificate.certificateHandler"> </mat-radio-button>
              </div>
              <div class="card-logo d-none d-lg-block">
                <span class="d-inline-block list-row-icon">
                  <i class="rt-icon rt-certificate fs35"></i>
                </span>
              </div>
              <div class="card-info">
                <div class="card-row">
                  <span class="card-col text highlight">
                    <span *ngIf="certificate?.alias">
                      {{ certificate.alias }}
                    </span>
                    <span class="text-danger d-inline-block" *ngIf="!certificate?.alias">
                      {{ 'WEB-SIGN.SIGNTRUST-LIB.CERTIFICATES-LIST.CARD.DETAILS.NO-ALIAS' | translate }}
                    </span>
                  </span>
                </div>
                <div class="card-row">
                  <span class="card-col text">
                    {{ 'WEB-SIGN.SIGNTRUST-LIB.CERTIFICATES-LIST.CARD.ISSUER' | translate }}&nbsp;
                    <span *ngIf="certificate?.issuer"> {{ certificate.issuer }},&nbsp; </span>
                    <span class="text-danger d-inline-block" *ngIf="!certificate?.issuer">
                      {{ 'WEB-SIGN.SIGNTRUST-LIB.CERTIFICATES-LIST.CARD.DETAILS.NO-ISSUER' | translate }}&nbsp;
                    </span>
                  </span>
                  <span class="card-col text">
                    {{ 'WEB-SIGN.SIGNTRUST-LIB.CERTIFICATES-LIST.CARD.EXPIRES' | translate }}&nbsp;
                    <span *ngIf="certificate?.expiration">
                      {{ certificate.expiration | dateMultiLang: 'currentLang':'small' }}
                    </span>
                    <span class="text-danger d-inline-block" *ngIf="!certificate?.expiration">
                      {{ 'WEB-SIGN.SIGNTRUST-LIB.CERTIFICATES-LIST.CARD.DETAILS.NO-EXPIRATION' | translate }}
                    </span>
                  </span>
                </div>
              </div>
              <div class="h-100 card-detail-button" (click)="$event.stopPropagation()" (onclick)="$event.stopPropagation()">
                <button
                  class="h-100 dialog-button"
                  (click)="$event.preventDefault(); $event.stopPropagation(); openDetailsDialog(certificate)">
                  {{ 'WEB-SIGN.SIGNTRUST-LIB.CERTIFICATES-LIST.CARD.VIEW-DETAILS' | translate }}
                </button>
              </div>
            </div>
          </div>
        </ng-container>
        <div *ngIf="dataSource?.filteredData.length === 0" class="w-100 p-1">
          <div *ngIf="dataSource?.filter" class="notify notify-info wb-ball">
            <span class="notify-message text-center">
              {{ 'WEB-SIGN.SIGNTRUST-LIB.NO-RESULTS-FOR' | translate }} <b class="fw-bold">"{{ dataSource.filter }}"</b>.
            </span>
          </div>
          <div *ngIf="!dataSource?.filter" class="notify notify-info wb-ball">
            <span class="notify-message text-center">
              {{ 'WEB-SIGN.SIGNTRUST-LIB.NO-RESULTS' | translate }}
            </span>
          </div>
        </div>

      </ng-template>
    </div>
  </div>
</div>
<div mat-dialog-actions class="w-100">
  <button mat-raised-button color="primary" class="ms-2 float-end" [disabled]="!selectCertificate" (click)="onSigning()">
    <i class="rt-icon rt-comprobado-1" *ngIf="isMobile"></i>
      <span *ngIf="!isMobile">{{ ((type === 'signing' || type === 'no-visual') ? 'GLOBAL.SIGN' : 'GLOBAL.CONTINUE') | translate }}</span>
  </button>

  <button mat-stroked-button color="primary" class="ms-auto" [mat-dialog-close]="false">
    <i class="rt-icon rt-cerrar" *ngIf="isMobile"></i>
      <span *ngIf="!isMobile">{{ 'WEB-SIGN.SIGNTRUST-LIB.CLOSE' | translate }}</span>
  </button>
</div>
